// 点餐相关
export default [
  {
    path: '/thunder/order_meal',
    component: () => import('@/views/order/index.vue'),
    name: 'order_test',
    meta: {
      title: '餐饮美食',
      level: 1,
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/order_shopcar',
    component: () => import('@/views/order/shop_car.vue'),
    name: 'order_shopcar',
    meta: {
      title: '购物车',
      notShowOrderList: true,
    },
  },
  {
    path: '/thunder/order_bill',
    component: () => import('@/views/order/bill.vue'),
    name: 'order_bill',
    meta: {
      title: '账单详情',
      notShowOrderList: true,
    },
  },
]
